"use client";
import * as React from "react";
const SvgAutoSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m13.76 4.48.7-1.54 1.54-.7-1.54-.7-.7-1.54-.7 1.54-1.54.7 1.54.7zm-8.6 0 .7-1.54 1.55-.7-1.54-.7L5.17 0l-.71 1.54-1.54.7 1.54.7zm8.6 4.11-.7 1.54-1.54.7 1.54.7.7 1.55.7-1.54 1.54-.7-1.54-.7zm-1.19-2L9.4 3.44 0 12.83 3.17 16zM9.43 7.64 8.38 6.58 9.4 5.55l1.05 1.05z" }));
export {
  SvgAutoSharp as default
};
